/** @jsxImportSource @emotion/react */
import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
  Box,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { buttonContainer } from './Button.styles'

export interface ButtonProps extends MuiButtonProps {
  children: React.ReactNode
  loading?: boolean
}

export const Button = ({ ...rest }: ButtonProps) => {
  const theme = useTheme()

  return (
    <MuiButton
      {...rest}
      variant={rest.variant ?? 'contained'}
      data-testid="btn"
      css={buttonContainer({ theme, rest })}
    >
      <Box
        css={{ position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)' }}
      >
        {rest.loading ? <CircularProgress size={24} color="inherit" /> : null}
      </Box>
      {rest.children}
    </MuiButton>
  )
}
